import { c as _c } from "react/compiler-runtime";
import type { InfiniteData } from '@tanstack/react-query';
import type { CommentListInput, CommentListOutput } from '@/orpc/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/orpc/client';
type CommentListInfiniteData = InfiniteData<CommentListOutput, undefined>;
export function useCreateVote(input) {
  const $ = _c(6);
  const queryClient = useQueryClient();
  let t0;
  let t1;
  if ($[0] !== input || $[1] !== queryClient) {
    let t2;
    if ($[4] !== input) {
      t2 = () => input;
      $[4] = input;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const queryKey = orpc.comment.list.infiniteKey({
      input: t2,
      initialPageParam: undefined
    });
    t0 = useMutation;
    t1 = orpc.vote.create.mutationOptions({
      onMutate: async newData => {
        await queryClient.cancelQueries({
          queryKey
        });
        const previousData = queryClient.getQueryData(queryKey);
        if (previousData) {
          queryClient.setQueryData(queryKey, {
            ...previousData,
            pages: previousData.pages.map(page => ({
              ...page,
              comments: page.comments.map(comment => {
                if (comment.id !== newData.id) {
                  return comment;
                }
                let {
                  likeCount,
                  dislikeCount
                } = comment;
                const liked = newData.isLike;
                if (comment.liked === true) {
                  likeCount = likeCount - 1;
                } else {
                  if (comment.liked === false) {
                    dislikeCount = dislikeCount - 1;
                  }
                }
                if (liked === true) {
                  likeCount = likeCount + 1;
                } else {
                  if (liked === false) {
                    dislikeCount = dislikeCount + 1;
                  }
                }
                return {
                  ...comment,
                  liked,
                  likeCount,
                  dislikeCount
                };
              })
            }))
          });
        }
        return {
          previousData
        };
      },
      onError: (_error, _variables, context) => {
        if (context?.previousData) {
          queryClient.setQueryData(queryKey, context.previousData);
        }
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey
        });
      }
    });
    $[0] = input;
    $[1] = queryClient;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  return t0(t1);
}